import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "15",
  fill: "none",
  viewBox: "0 0 12 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.051 6.066 5.61 1.508l4.559 4.558a.625.625 0 0 0 .883-.883l-5-5a.625.625 0 0 0-.883 0l-5 5a.625.625 0 0 0 .883.883M10.168 8.933 5.609 13.49 1.051 8.933a.625.625 0 0 0-.883.883l5 5c.244.244.64.244.883 0l5-5a.625.625 0 0 0-.883-.883"
    }, null, -1)
  ]))]))
}
export default { render: render }